import React from 'react';
import { useTranslation } from 'react-i18next';
// import { motion } from 'framer-motion'; // Removed for static content
import { Heart, Users, Leaf, Award } from 'lucide-react';

const About = () => {
  const { t } = useTranslation();

  // Animation variants removed for static content

  return (
    <div className="about">
      <section 
        className="about-hero section"
      >
        <div className="about-header">
          <Users className="header-icon" />
          <h1>{t('about.title')}</h1>
          <div className="hero-images-about">
            <img src="/images/WechatIMG182.jpg" alt="Pacific 91" className="about-hero-img" />
            <img src="/images/WechatIMG183.jpg" alt="Pacific 91" className="about-hero-img" />
          </div>
        </div>
      </section>

      <section className="history-section section">
        <div className="history-content glass-card">
          <div className="content-with-icon">
            <Heart className="section-icon" />
            <div>
              <h2>{t('about.history.title')}</h2>
              <p>{t('about.history.content')}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="philosophy-section section">
        <div className="philosophy-content">
          <div className="philosophy-text glass-card">
            <div className="content-with-icon">
              <Award className="section-icon" />
              <div>
                <h2>{t('about.philosophy.title')}</h2>
                <p className="motto">"{t('about.philosophy.motto')}"</p>
                <p>{t('about.philosophy.content')}</p>
              </div>
            </div>
          </div>
          
          <div className="philosophy-images">
            <img src="/images/WechatIMG184.jpg" alt="Cuisine" className="philosophy-img" />
            <img src="/images/WechatIMG185.jpg" alt="Restaurant" className="philosophy-img" />
          </div>
        </div>
      </section>

      <section className="team-section section">
        <div className="team-content">
          <div className="team-images">
            <img src="/images/WechatIMG187.jpg" alt="Team" className="team-img" />
            <img src="/images/WechatIMG188.jpg" alt="Service" className="team-img" />
          </div>
          
          <div className="team-text glass-card">
            <div className="content-with-icon">
              <Users className="section-icon" />
              <div>
                <h2>{t('about.team.title')}</h2>
                <p>{t('about.team.content')}</p>
                
                <div className="engagements">
                  <h3>Nos engagements :</h3>
                  {t('about.team.engagements', { returnObjects: true }).map((engagement, index) => (
                    <div 
                      key={index}
                      className="engagement-item"
                    >
                      <Leaf className="engagement-icon" />
                      <p>{engagement}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <style jsx>{`
        .about {
          min-height: 100vh;
        }

        .about-header {
          text-align: center;
          margin-bottom: 2rem;
        }

        .header-icon {
          color: #64b5f6;
          width: 4rem;
          height: 4rem;
          margin: 0 auto 1rem;
        }

        .about-header h1 {
          font-size: 3rem;
          margin-bottom: 2rem;
        }

        .hero-images-about {
          display: flex;
          gap: 2rem;
          justify-content: center;
          max-width: 800px;
          margin: 0 auto;
        }

        .about-hero-img {
          width: 100%;
          height: 300px;
          object-fit: cover;
          border-radius: 20px;
          box-shadow: 0 8px 32px rgba(31, 38, 135, 0.37);
          border: 1px solid rgba(255, 255, 255, 0.2);
        }

        .content-with-icon {
          display: flex;
          gap: 2rem;
          align-items: flex-start;
        }

        .glass-card {
          background: rgba(255, 255, 255, 0.05);
          backdrop-filter: blur(10px);
          -webkit-backdrop-filter: blur(10px);
          border-radius: 20px;
          border: 1px solid rgba(255, 255, 255, 0.18);
          padding: 2.5rem;
          box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }

        .glass-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 12px 40px 0 rgba(31, 38, 135, 0.45);
        }

        .section-icon {
          color: #64b5f6;
          width: 3rem;
          height: 3rem;
          flex-shrink: 0;
          margin-top: 0.5rem;
          margin-bottom: 0;
        }

        .motto {
          font-size: 1.3rem;
          font-style: italic;
          color: #64b5f6;
          font-weight: 600;
          margin: 1.5rem 0;
          text-align: center;
          background: linear-gradient(135deg, rgba(100, 181, 246, 0.15) 0%, rgba(100, 181, 246, 0.05) 100%);
          padding: 1rem;
          border-radius: 15px;
          border-left: 4px solid #64b5f6;
          position: relative;
          overflow: hidden;
        }

        .motto::before {
          content: '';
          position: absolute;
          top: -50%;
          left: -50%;
          width: 200%;
          height: 200%;
          background: radial-gradient(circle, rgba(100, 181, 246, 0.1) 0%, transparent 70%);
          animation: pulse 4s ease-in-out infinite;
        }

        @keyframes pulse {
          0%, 100% {
            transform: scale(1);
            opacity: 0.5;
          }
          50% {
            transform: scale(1.1);
            opacity: 0;
          }
        }

        .values-list h3 {
          color: #64b5f6;
          margin: 2rem 0 1rem;
        }

        .values-list ul {
          list-style: none;
          padding: 0;
        }

        .values-list li {
          padding: 0.5rem 0;
          padding-left: 1.5rem;
          position: relative;
          color: rgba(255, 255, 255, 0.9);
        }

        .values-list li::before {
          content: "●";
          color: #64b5f6;
          position: absolute;
          left: 0;
        }

        .philosophy-content {
          display: grid;
          grid-template-columns: 1.2fr 1fr;
          gap: 4rem;
          align-items: center;
          max-width: 1400px;
          margin: 0 auto;
        }

        .philosophy-text {
          animation: slideInLeft 0.8s ease-out;
        }

        .philosophy-images {
          display: grid;
          grid-template-columns: 1fr;
          gap: 2rem;
          animation: slideInRight 0.8s ease-out;
        }

        .philosophy-img {
          width: 100%;
          height: 280px;
          object-fit: cover;
          border-radius: 20px;
          box-shadow: 0 12px 40px rgba(31, 38, 135, 0.4);
          border: 1px solid rgba(255, 255, 255, 0.2);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }

        .philosophy-img:hover {
          transform: translateY(-5px);
          box-shadow: 0 16px 48px rgba(100, 181, 246, 0.3);
        }

        .philosophy-img:nth-child(1) {
          transform: translateX(-20px);
        }

        .philosophy-img:nth-child(2) {
          transform: translateX(20px);
        }

        .team-content {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 3rem;
          align-items: center;
        }

        .team-images {
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
        }

        .team-img {
          width: 100%;
          height: 250px;
          object-fit: cover;
          border-radius: 20px;
          box-shadow: 0 8px 32px rgba(31, 38, 135, 0.37);
          border: 1px solid rgba(255, 255, 255, 0.2);
        }

        .engagements h3 {
          color: #64b5f6;
          margin: 2rem 0 1rem;
        }

        .engagement-item {
          display: flex;
          gap: 1rem;
          align-items: flex-start;
          margin: 1rem 0;
          padding: 1rem;
          background: rgba(255, 255, 255, 0.05);
          border-radius: 15px;
          border-left: 3px solid #4caf50;
        }

        .engagement-icon {
          color: #4caf50;
          width: 1.5rem;
          height: 1.5rem;
          flex-shrink: 0;
          margin-top: 0.2rem;
        }

        .engagement-item p {
          margin: 0;
          color: rgba(255, 255, 255, 0.9);
          line-height: 1.6;
        }

        @keyframes slideInLeft {
          from {
            opacity: 0;
            transform: translateX(-50px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes slideInRight {
          from {
            opacity: 0;
            transform: translateX(50px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @media (min-width: 1024px) {
          .philosophy-content {
            grid-template-columns: 1.3fr 1fr;
            gap: 5rem;
          }

          .philosophy-images {
            grid-template-columns: 1fr 1fr;
            gap: 2rem;
          }

          .philosophy-img {
            height: 300px;
          }

          .philosophy-img:nth-child(1) {
            transform: translateY(-20px) translateX(0);
          }

          .philosophy-img:nth-child(2) {
            transform: translateY(20px) translateX(0);
          }

          .motto {
            font-size: 1.5rem;
            padding: 1.5rem;
          }
        }

        @media (min-width: 768px) and (max-width: 1023px) {
          .philosophy-content {
            grid-template-columns: 1fr;
            gap: 3rem;
          }

          .philosophy-images {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 2rem;
            order: -1;
          }

          .philosophy-img {
            height: 250px;
          }

          .philosophy-img:nth-child(1),
          .philosophy-img:nth-child(2) {
            transform: none;
          }

          .philosophy-text {
            max-width: 800px;
            margin: 0 auto;
          }
        }

        @media (max-width: 768px) {
          .about-hero {
            padding-top: 0 !important;
          }

          .about-header h1 {
            font-size: 2.5rem;
          }

          .hero-images-about {
            flex-direction: column;
            gap: 1rem;
          }

          .content-with-icon {
            flex-direction: column;
            gap: 1rem;
          }

          .section-icon {
            align-self: center;
          }

          .philosophy-content,
          .team-content {
            grid-template-columns: 1fr;
            gap: 2rem;
          }

          .philosophy-images,
          .team-images {
            order: -1;
            grid-template-columns: 1fr;
          }

          .philosophy-img {
            height: 200px;
          }

          .philosophy-img:nth-child(1),
          .philosophy-img:nth-child(2) {
            transform: none;
          }

          .motto {
            font-size: 1.1rem;
            padding: 0.8rem;
          }
        }

        @media (max-width: 480px) {
          .about-hero {
            padding-top: 0 !important;
          }
        }
      `}</style>
    </div>
  );
};

export default About; 